
import { useTheme } from '@mui/material';

export const useDataGridStyles = () => {
  const theme = useTheme();

  return {
    root: {
      border: 'none',
      width: '100%',
      fontSize: '0.825rem',
      flexGrow: 1,
    },
    layout: {
      '& .MuiDataGrid-main': {
        width: '100%',
        flexGrow: 1,
      },
      '& .MuiDataGrid-virtualScroller': {
        width: '100%',
        display: 'flex',
        flex: 1,
      },
      '& .MuiDataGrid-filler': {
        display: 'none',
        flex: 0,
      },
      '& .MuiDataGrid-virtualScrollerContent': {
        width: '100%',
        flex: 1,
      },
      '& .MuiDataGrid-virtualScrollerRenderZone': {
        width: '100%',
      },
    },
    cells: {
      '& .MuiDataGrid-cell': {
        padding: '0px 16px',
        borderBottom: `1px solid ${theme.palette.divider}`,
        maxHeight: '42px !important',
        minHeight: '42px !important',
      },
      '& .MuiDataGrid-columnHeader': {
        padding: '0px 16px',
        height: '40px',
      },
      '& .MuiDataGrid-row': {
        maxHeight: '42px !important',
        minHeight: '42px !important',
      },
    },
    headers: {
      '& .MuiDataGrid-columnHeaders': {
        maxHeight: '40px !important',
        minHeight: '40px !important',
        backgroundColor: theme.palette.mode === 'dark'
          ? 'rgba(36, 42, 56, 0.8)'
          : '#e4e8ef',
        borderBottom: `1px solid ${theme.palette.divider}`,
      },
    },
    focus: {
      '& .MuiDataGrid-cell:focus-within': {
        outline: 'none',
      },
    },
  };
};
